const addToCartForm = document.querySelectorAll('form[action="/cart/add"]');
addToCartForm.forEach(form=>{
    form.addEventListener('submit', (e)=>{
e.preventDefault();
    })
})


const btn = document.querySelectorAll(".shop-button-sticky");
const hideBtn = document.querySelectorAll(".shop-button-hide");
   console.log("btn", btn);
 var sticky = header.offsetTop + 649;



addEventListener("load", (event) => {
  addEventListener("scroll", (event) => {
      

   if (window.pageYOffset > sticky) {
    btn[0].style.cssText = `
      opacity: 0;
    `;
  } else {
   btn[0].style.cssText = `
      opacity: 1;
    `;
  }
  });

  
  
});

$(document).ready(function () {
  const selectElement = $('#productSelect-option-0');

  function toggleSelectVisibility() {
    if (selectElement.val() === 'Default Title') {
      selectElement.hide();
    } else {
      selectElement.show();
    }
  }

  // Run on page load
  toggleSelectVisibility();

  // Run when the select value changes
  selectElement.on('change', toggleSelectVisibility);
});






